import { UnlinkedExternalAccountsRepo, UnlinkedExternalAccount } from "@services/portfolios/unlinked-external-accounts.repo";
import { ClientRepo } from "@services/clients/client.repo";

interface TableColumn {
    key: string;
    label: string;
    width?: string;
    type?: 'text' | 'date' | 'number';
}

export class UnlinkedExternalAccountsController implements angular.IOnInit {
    public accounts: UnlinkedExternalAccount[] = [];
    public loading: boolean = false;
    public tableColumns: TableColumn[] = [
        { key: 'accountNumber', label: 'Account Number', width: 'col-md-2' },
        { key: 'accountSourceName', label: 'Account Source', width: 'col-md-2' },
        { key: 'portfolioName', label: 'Portfolio', width: 'col-md-2' },
        { key: 'cashAccountsCount', label: 'Cash Accounts', width: 'col-md-1', type: 'number' },
        { key: 'securityBalancesCount', label: 'Security Balances', width: 'col-md-1', type: 'number' },
        { key: 'cashAccountBalancesCount', label: 'Cash Balances', width: 'col-md-1', type: 'number' },
        { key: 'tradeAccountsCount', label: 'Trade Accounts', width: 'col-md-1', type: 'number' },
        { key: 'tradeSetsCount', label: 'Trade Sets', width: 'col-md-1', type: 'number' },
        { key: 'custodianReportsCount', label: 'Custodian Reports', width: 'col-md-1', type: 'number' },
        { key: 'portfolioBalancesCount', label: 'Portfolio Balances', width: 'col-md-1', type: 'number' },
        { key: 'totalLinkedAccounts', label: 'Total Linked', width: 'col-md-1', type: 'number' }
    ];

    static $inject = [
        'unlinkedExternalAccountsRepo',
        'clientRepo',
        'notifyjs',
        '$mdDialog',
        '$rootScope'
    ];

    constructor(
        private unlinkedExternalAccountsRepo: UnlinkedExternalAccountsRepo,
        private clientRepo: ClientRepo,
        private notifyjs: any,
        private $mdDialog: angular.material.IDialogService,
        private $rootScope: angular.IRootScopeService
    ) {}

    $onInit(): void {
        this.loadAccounts();
    }

    loadAccounts(): void {
        this.loading = true;
        this.unlinkedExternalAccountsRepo.getUnlinkedExternalAccounts()
            .then((response: any) => {
                this.accounts = response.data;
            })
            .catch((error) => {
                this.notifyjs('Failed to load unlinked external accounts', 'error');
                console.error('Error loading accounts:', error);
            })
            .finally(() => {
                this.loading = false;
            });
    }

    editAccount(account: UnlinkedExternalAccount): void {
        const tempScope = this.$rootScope.$new(true) as any;
        tempScope.account = account;

        this.$mdDialog.show({
            template: '<md-dialog flex="30" aria-label="Link Account Dialog"><link-account-modal account="account"></link-account-modal></md-dialog>',
            scope: tempScope,
            clickOutsideToClose: true,
            escapeToClose: true
        }).then((result) => {
            if (result && result.success) {
                this.notifyjs('Account successfully linked to client', 'success');
                this.loadAccounts(); // Refresh the list
            }
        }).catch(() => {
            // Dialog was cancelled
        });
    }

    refreshAccounts(): void {
        this.loadAccounts();
    }
}

export const unlinkedExternalAccountsComponent = {
    template: require('./unlinked-external-accounts.component.html'),
    controller: UnlinkedExternalAccountsController,
    controllerAs: '$ctrl'
};



// WEBPACK FOOTER //
// ./src/app/clientmanagement/unlinked-external-accounts/unlinked-external-accounts.component.ts